import React from 'react';

import { PropsWithLocation } from '@model';

import './footer.scss';
import { Link } from 'gatsby';

interface FooterProps extends PropsWithLocation {
  className?: string;
}

function Footer(props: FooterProps) {
  const { location, className } = props;
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`footer ${className || ''}`}>
      <div className='copyright'>
        <span>The Claims Guys Legal &copy; Copyright {currentYear} </span>
        <br />
      </div>
      <div className='disclaimer'>
        <span>The Claims Guys Legal Limited is authorised and regulated by the Solicitors Regulation Authority (SRA Number: 642517).</span>
      </div>

      <div className='disclaimer'>
        <span>
          ^See:{' '}
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://cardealermagazine.co.uk/publish/car-finance-scandal-could-cost-lenders-30bn-warns-leading-ratings-agency/310122'
          >
            https://cardealermagazine.co.uk/publish/car-finance-scandal-could-cost-lenders-30bn-warns-leading-ratings-agency/310122
          </a>
        </span>
      </div>

      <div className='disclaimer'>
        <span>
          *See:{' '}
          <a target='_blank' rel='noopener noreferrer' href='https://www.fca.org.uk/publication/consultation/cp24-22.pdf'>
            https://www.fca.org.uk/publication/consultation/cp24-22.pdf, Annex 2, Pg30.
          </a>
        </span>
      </div>
      <ul className='links'>
        <li className='footer-link'>
          <Link to='/company-information'>Company Information</Link>
        </li>
        <li className='footer-link'>
          <Link to='/terms'>Terms of Use</Link>
        </li>
        <li className='footer-link'>
          <Link to='/privacy-policy'>Privacy Policy</Link>
        </li>
        <li className='footer-link'>
          <Link to='/complaints'>Complaints & Feedback</Link>
        </li>
      </ul>
    </footer>
  );
}

export { Footer };
